// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".m-comments span {\n  cursor: pointer;\n  text-decoration: underline;\n}\n.m-comments span:hover {\n  text-decoration: none;\n}\n.text-column-center {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n", ""]);
// Exports
module.exports = exports;
